export const dbPanels = {
  images: {
    subtitle: `Upload, reorder and set the main photo of each unit shown in your booking engine.`,
  },

  amenities: {
    searchPlaceholder: `Search amenity…`,
    selectedCount: `{count} amenity selected | {count} amenities selected`,
    noResults: `No results for "{query}".`,
    // Fotos por comodidad: lo que el Agente IA le enseña al huésped.
    photos: {
      explain: `The agent will show them to any guest who asks about this amenity.`,
      dropTitle: `Drag your photos here`,
      addPhotos: `Add photos`,
      dropHint: `JPG, PNG, WebP or HEIC · up to {mb} MB each`,
      dropActive: `Drop to upload`,
      uploading: `Uploading… {progress}%`,
      uploaded: `{count} photo added | {count} photos added`,
      counter: `{count} photo | {count} photos`,
      remaining: `You can add {count} more photo | You can add {count} more photos`,
      full: `It already has the maximum of {max} photos`,
      tooMany: `Only {max} photos fit per amenity.`,
      tooHeavy: `“{name}” is over {mb} MB. Make it smaller before uploading.`,
      notImage: `“{name}” is not an image.`,
      uploadError: `The photos couldn't be uploaded.`,
      removeAria: `Remove this photo`,
      deleteTitle: `Remove this photo?`,
      deleteBody: `The agent will stop showing it when guests ask about “{amenity}”. This can't be undone.`,
      deleteCancel: `Cancel`,
      deleteConfirm: `Remove photo`,
      deleted: `Photo removed`,
      deleteError: `The photo couldn't be removed.`,
      // Orden: el agente solo manda las primeras, por eso se puede arrastrar.
      orderHint: `The agent shows the first {count}. Drag by the handle to change the order.`,
      dragTitle: `Drag to reorder`,
      reordering: `Saving the order…`,
      orderSaved: `Order saved`,
      orderError: `The order couldn't be saved.`,
      willSend: `The agent will send this photo`,
      wontSend: `The agent won't get as far as this photo`,
      someFailed: `Couldn't be processed: {names}`,
    },
  },

  occupancy: {
    question: `Which adjustment would you like to apply?`,
    questionRoom: `Which adjustment would you like to apply to this room?`,
    modeNone: `None`,
    modeReduction: `Reduction`,
    modeSurcharge: `Surcharge`,
    baseOccupancy: `Base occupancy`,
    baseHint: `guests (the standard price)`,
    thOccupancy: `Occupancy`,
    thRule: `Rule`,
    thValue: `Value`,
    thActive: `Active`,
    guestsCount: `{count} guest | {count} guests`,
    ruleReductionPct: `Reduction %`,
    ruleReductionFixed: `Reduction {currency}`,
    reductionInfo: `For fewer guests than the base occupancy, this reduction applies to the accommodation price.`,
    priceIncludes: `The price includes`,
    guestsCapacity: `guest (room capacity) | guests (room capacity)`,
    maxExtraGuests: `Max. extra guests`,
    chargePerExtraGuest: `Charge per extra guest`,
    chargeFixed: `{currency} fixed`,
    perNight: `per night`,
    surchargeInfo: `Each guest above the included capacity pays this charge per night.`,
    noneRoom: `This room has no occupancy adjustment: the same price for any number of guests (within capacity).`,
    noneBooking: `This booking has no occupancy adjustment: the same price for any number of guests (within capacity).`,
  },

  share: {
    title: `Share (Hotel)`,
    desc: `This link is specific to this hotel. Share it via WhatsApp or open it as a visitor.`,
    linkLabel: `Hotel booking link`,
    linkHint: `Use it in your bio, campaigns or automated messages.`,
    viewAsVisitor: `View as visitor`,
    tip: `Tip: You can send this link with your booking confirmation message.`,
    noLinkCopy: `No link to copy.`,
    copied: `Link copied.`,
    copyError: `Couldn't copy the link.`,
    noLinkShare: `No link to share.`,
    whatsappMsg: `Hi 👋 Here's the link to book at this hotel: {link}`,
    noLinkOpen: `No link to open.`,
  },

  unitServices: {
    title: `Equipment and amenities`,
    subPrefix: `Amenities for`,
    thisRoom: `this room`,
    subInfo: `Each room type has its own; direct booking and the AI Agent use those of the room assigned to the guest.`,
    loading: `Loading amenities…`,
    loadError: `Couldn't load this room's amenities.`,
    retry: `Retry`,
    saving: `Saving…`,
    saved: `Saved`,
    autosaveHint: `Changes save automatically as you check or uncheck.`,
  },

  welcome: {
    tag: `Direct booking engine`,
    titleA: `Get bookings`,
    titleHighlight: `commission-free`,
    sub: `Your own booking engine per property: share a link, the guest books and pays directly. No middlemen, no OTA commissions.`,
    howItWorks: `How it works`,
    benefits: `Benefits`,
    step1Title: `Share your link`,
    step1Text: `Each property has its own link. Post it on your website, social media or WhatsApp; the AI agent also sends it to leads.`,
    step2Title: `The guest books`,
    step2Text: `They pick dates and pay in your engine. The booking lands straight in your calendar, with no OTA commissions.`,
    step3Title: `You get paid directly`,
    step3Text: `Receive payment with no middlemen and add promotions, charges and extra services to every stay.`,
    ctaStart: `Start setting up`,
    ctaPromotions: `View global promotions`,
    perk1Title: `Zero OTA commissions`,
    perk1Text: `Keep 100% of every direct booking.`,
    perk2Title: `Instant payment and confirmation`,
    perk2Text: `The guest pays and the booking confirms itself.`,
    perk3Title: `Promotions and extra charges`,
    perk3Text: `Stay discounts, services and your own charges.`,
    perk4Title: `One link per property`,
    perk4Text: `Each listing with its own engine and availability.`,
  },

  unitsList: {
    title: `Available units`,
    subtitle: `Enable the units you want to show in your booking engine.`,
    loading: `Loading…`,
    sectionUnits: `Units`,
    colUnit: `Unit`,
    colCap: `Cap.`,
    colActive: `Active`,
    noUnits: `No units configured.`,
    active: `Active`,
    inactive: `Inactive`,
    noticePrefix: `Enable direct bookings from`,
    noticeGlobalConfig: `Global settings`,
    noticeSuffix: `to manage the units.`,
    sectionLink: `Individual apartment link`,
    linkCardTitle: `Filtered link for this apartment`,
    linkCardDesc: `Opens the same general booking engine, but showing this apartment directly.`,
    viewAsVisitor: `View as visitor`,
    unitUpdated: `Unit updated.`,
    updateError: `Couldn't update.`,
    noLinkCopy: `No link to copy.`,
    linkCopied: `Link copied.`,
    copyError: `Couldn't copy the link.`,
    noLinkOpen: `No link to open.`,
  },

  commonAreaImages: {
    intro: `General photos (entrance, pool, reception, garden…) shown to the guest as the cover when they open the engine, alongside each unit's gallery.`,
    imagesCount: `{count} image | {count} images`,
    reorderHint: `Drag to reorder · the main one is the cover`,
    reordering: `Reordering…`,
    dragTitle: `Drag`,
    coverBadge: `Cover`,
    empty: `You haven't added any common-area photos yet. Upload them above to create the listing cover.`,
    loadError: `Couldn't load the common-area photos.`,
    uploadSuccess: `Photos uploaded successfully.`,
    uploadError: `Couldn't upload the images.`,
    orderUpdated: `Order updated.`,
    orderError: `Couldn't update the order.`,
    deleteConfirmMsg: `Delete this common-area photo?`,
    deleteConfirmHeader: `Delete image`,
    deleteAccept: `Delete`,
    deleteReject: `Cancel`,
    imageDeleted: `Image deleted.`,
    deleteError: `Couldn't delete the image.`,
    coverUpdated: `Cover updated.`,
    coverError: `Couldn't set the cover.`,
    invalidFiles: `Invalid files: {message}\n{details}`,
  },
};
